import React, { useState, useEffect, useRef } from 'react';

const UserMenu = ({ username, onLogout, isDarkMode, onToggleTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="user-menu" ref={menuRef}>
      <button className="user-menu-button" onClick={() => setIsOpen(!isOpen)}>
        <i className="fas fa-user-circle"></i>
        <span>{username}</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`} style={{ fontSize: '12px', opacity: 0.7 }}></i>
      </button>
      {isOpen && (
        <div className="user-menu-dropdown">
          <div className="user-info">
            <i className="fas fa-user-circle"></i>
            <div>
              <span>{username}</span>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                {isDarkMode ? 'Dark Mode Active' : 'Light Mode Active'}
              </div>
            </div>
          </div>
          <button onClick={onToggleTheme}>
            <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}></i>
            {isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          </button>
          <button onClick={onLogout}>
            <i className="fas fa-sign-out-alt"></i>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu; 